<template>
  <div class="form-group">
    <label for="pricerowRateplan">{{ _('Rate plan') }}</label>
    <select class="form-control" id="pricerowRateplan" :value="pricerow.rateplan_id ? String(pricerow.rateplan_id) : ''" v-on:change="$emit('data', { rateplan_id: $event.target.value ? $event.target.value : null })">
      <option value="">{{ _('All rates') }}</option>
      <option v-for="rateplan in rateplans" :value="String(rateplan.id)">{{ rateplan.title }}</option>
    </select>
  </div>
</template>

<script>
// Activity pricing: the rate plan a price row belongs to (empty = the row applies to every rate plan)
export default {
  props: ['pricerow', 'rateplans']
}
</script>
